/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { VIDEO_TYPES } from '../../config/const.config';
import convertSecToTime from '../../utils/timeformat.util';
import Player from '../common/Player';
import { addLocalStorageData } from '../../utils/localCache.util';
import defaultImageUrl from "../../assets/images/freemovies/default_image.png";

const Item = ({
  id,
  videoId,
  playlist_id,
  seriesId,
  title,
  description,
  shortDescription,
  long_description,
  hlsUrl,
  poster,
  posterH,
  posterV,
  startTime,
  endTime,
  duration,
  progress,
  genres,
  category,
  channelId,
  director,
  actor1,
  actor2,
  actor3,
  rating,
  releaseDate,
  ratingSource,
  season,
  episode,
  srtUrl,
  vttUrl,
  source,
  playDirectUrl,
  liveVastUrl,
  type,
  dataFocusLeft,
  dataFocusRight,
  dataFocusUp,
  dataFocusDown,
  dataOnSelfFocus,
  handleShowDetailPage,
  dataOnPagination,
  activePage,
  activeSubPage,
  detailPageData,
  ppc_spotlight_active,
  background_image_video,
  ppc_background_image,
  background_video_url,
  ppc_dark_overlay,
  ppc_watch_now_url,
  ppc_trailer_url,
  seriesCount,
  release_date,
  episode_count,
  menuData,
  subMenuData,
  isSeries,
}) => {
  const location = useLocation();
  const [showPlayer, setShowPlayer] = useState(false);
  const [currentUrl, setCurrentUrl] = useState();
  const page_url = activePage ? activePage : localStorage.getItem('pageClick');
  const [pageTitle, setPageTitle] = useState();
  const [pageSubTitle, setPageSubTitle] = useState();
  const getactiveSubPage = localStorage.getItem('pageSubClick');
  const pageSubClick = getactiveSubPage ? getactiveSubPage : activeSubPage;
  const showProgress = Math.floor((progress * 100) / duration);
  const isPortrait = type === VIDEO_TYPES.MOVIES;
  const [imageFailed, setImageFailed] = useState(false);
  const [seriesSubTitle, setSeriesSubTitle] = useState();

  const fallbackImage = (error, titleName) => {
    const errorElement = window.document.getElementById(error.target.id);
    if (error?.target) {
      errorElement.outerHTML = `<img src="${defaultImageUrl}" alt="${titleName}" class="error-image-default-image"/>`;
      setImageFailed(true);
    }
    return error;
  };

  const handlePlayerOpen = (fromProgress) => {
    const navbar = document.querySelector('.detailPage_navbar');
    const back_button = document.querySelector('.fullscreen-container-fixed .back-to-page');
    if (navbar) {
      navbar.style.display = 'none';
      back_button.style.top = '35px';
    }
    setShowPlayer(true);
  };

  const handlePlayerClose = () => {
    setShowPlayer(false);
  };

  useEffect(() => {
    const pathname = location.pathname;
    const segments = pathname.split('/');
    segments.pop();
    const basePath = segments.join('/');

    if (basePath !== currentUrl) {
      setCurrentUrl(basePath);
    }
  }, [location, currentUrl]);

  useEffect(() => {
    const page_url = activePage ? Number(activePage) : Number(localStorage.getItem('pageClick'));
    const matchedMenuItem = menuData.find(item => item.id === page_url);
    const matchedTitle = matchedMenuItem ? matchedMenuItem.title : 'Unknown';
    setPageTitle(matchedTitle.toLowerCase().replace(/\s+/g, '_'));
  }, [currentUrl, activePage, menuData]);

  useEffect(() => {
    if (subMenuData && Array.isArray(subMenuData)) {
      const subTitle = subMenuData.find((item) => item.id === playlist_id);
      if (subTitle) {
        setPageSubTitle(subTitle.title.replace(/\s+/g, '_').toLowerCase());
      }
    } else {
      setPageSubTitle(subMenuData);
    }
  }, [subMenuData, playlist_id]);

  const handleSeriesId = (seriesId) => {
    addLocalStorageData('seriesId', seriesId);
  }

  useEffect(() => {
    if (subMenuData && pageSubClick) {
      if (location.pathname !== "/search") {
        const matchedItem = subMenuData.find(item => item.id === Number(pageSubClick));
        if (matchedItem) {
          setSeriesSubTitle(matchedItem.title.toLowerCase().replace(/\s+/g, '_'));
        }
      } else {
        setSeriesSubTitle(subMenuData);
      }
    }
  }, [subMenuData, pageSubClick]);

  return (
    <>
    {isSeries === true && (
      <Link
        to={`/${pageTitle}/series/${seriesSubTitle}/${title.toLowerCase().replace(/\s+/g, '_')}`}
        className={`media-element portrait prj-element`}
        data-focus-left={dataFocusLeft || false}
        data-focus-right={dataFocusRight || false}
        data-focus-up={dataFocusUp || false}
        data-focus-down={dataFocusDown || false}
        data-on-self-focus={dataOnSelfFocus || false}
        data-focus-pagination={dataOnPagination}
        onClick={() => {
          handleSeriesId(id);
          handleShowDetailPage({
            id: seriesId,
            title,
            shortDescription,
            long_description,
            posterH,
            posterV,
            release_date,
            episode_count,
          });
        }}
        role="none"
      >
        <div className="img">
            <div className="overlay-box" >
              <div className="btns-group">
                <button className="btn" type='button'>Details</button>
              </div>
            </div>
          <div className="img-container">
            <img
              id={`target-image-h-v-${seriesId}`}
              src={posterV}
              alt={title}
              loading="lazy"
              onError={(error) => fallbackImage(error, title)}
            />
          </div>
          {duration > 0 && showProgress > 0 && (
            <div className="progress-wrapper">
              <div className="progress-bar">
                <span
                  className="progress-bar-fill"
                  style={{ width: `${showProgress}%` }}
                />
              </div>
            </div>
          )}
        </div>

        {imageFailed && (
          <div className="title-wrapper">
            <span className="error-title">{title}</span>
          </div>
        )}

        {/* {type !== VIDEO_TYPES.MOVIES && <p className="title">{title}</p>} */}
        {type === VIDEO_TYPES.VIDEO && (
          <p className="sub-title">{description}</p>
        )}
      </Link>
    )}
    {isSeries === false && (
      <Link
        to={`/${pageTitle}/${pageSubTitle}/${title.toLowerCase().replace(/\s+/g, '_')}`}
        className={`media-element ${
          isPortrait ? 'portrait' : 'landscape'
        } prj-element`}
        data-focus-left={dataFocusLeft || false}
        data-focus-right={dataFocusRight || false}
        data-focus-up={dataFocusUp || false}
        data-focus-down={dataFocusDown || false}
        data-on-self-focus={dataOnSelfFocus || false}
        data-focus-pagination={dataOnPagination}
        onClick={() => {
          handleShowDetailPage({
            id: videoId,
            title,
            description,
            poster,
            posterH,
            posterV,
            hlsUrl,
            genres,
            duration,
            category,
            channelId,
            director,
            actor1,
            actor2,
            actor3,
            rating,
            releaseDate,
            ratingSource,
            season,
            episode,
            srtUrl,
            vttUrl,
            source,
            playDirectUrl,
            liveVastUrl,
            isPortrait,
            ppc_spotlight_active,
            ppc_background_image,
            ppc_dark_overlay,
            ppc_watch_now_url,
            ppc_trailer_url,
            background_image_video,
            background_video_url,
          });
        }}
        role="none"
      >
        <div className="img">
          <div className="overlay-box">
            <div className="btns-group">
              <Link
                to={`/watch/featured/${title.toLowerCase().replace(/\s+/g, '_')}`}
                className="btn" type='button'
                data-focus-left="#resume-btn"
                data-focus-right={false}
                data-focus-up={false}
                data-focus-down=".video.prj-element"
                data-on-self-focus="#video-detail-focus"
                onClick={() => {
                  handlePlayerOpen(false);
                }}
              >
                {type !== VIDEO_TYPES.MOVIES ? (
                  <div className="icon-parent">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="size-6"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                ) : (
                  "Play"
                )}
              </Link>
              {type !== VIDEO_TYPES.VIDEO && (
                <button className="btn" type='button'>Details</button>
              )}
            </div>
          </div>
          <div className="img-container">
            <img
              id={`target-image-h-v-${videoId}`}
              src={isPortrait ? posterV : posterH}
              alt={title}
              loading="lazy"
              onError={(error) => fallbackImage(error, title)}
            />
          </div>
          {type === VIDEO_TYPES.VIDEO && (
            <div className="video-duration">{convertSecToTime(duration)}</div>
          )}
          {duration > 0 && showProgress > 0 && (
            <div className="progress-wrapper">
              <div className="progress-bar">
                <span
                  className="progress-bar-fill"
                  style={{ width: `${showProgress}%` }}
                />
              </div>
            </div>
          )}
        </div>

        {type !== VIDEO_TYPES.MOVIES && <p className="title">{title}</p>}
        {type === VIDEO_TYPES.VIDEO && (
          <p className="sub-title">{description}</p>
        )}
        {type === VIDEO_TYPES.MOVIES && currentUrl !== "/channels/details" && (
          <div className="content">
            <h4>{title}</h4>
            <p>{description}</p>
            <div className="flex-box">
              <span>Published: <b>{releaseDate}</b></span>
              <span>Duration: <b>{convertSecToTime(duration)}</b></span>
            </div>
          </div>
        )}
      </Link>
      )}
    </>
  );
};

Item.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  videoId: PropTypes.number,
  description: PropTypes.string,
  shortDescription: PropTypes.string,
  hlsUrl: PropTypes.string,
  poster: PropTypes.string,
  posterH: PropTypes.string,
  posterV: PropTypes.string,
  startTime: PropTypes.string,
  endTime: PropTypes.string,
  duration: PropTypes.number,
  progress: PropTypes.number,
  genres: PropTypes.string,
  category: PropTypes.string,
  channelId: PropTypes.number,
  director: PropTypes.string,
  actor1: PropTypes.string,
  actor2: PropTypes.string,
  actor3: PropTypes.string,
  rating: PropTypes.string,
  releaseDate: PropTypes.string,
  ratingSource: PropTypes.string,
  season: PropTypes.number,
  episode: PropTypes.number,
  srtUrl: PropTypes.string,
  vttUrl: PropTypes.string,
  source: PropTypes.string,
  playDirectUrl: PropTypes.string,
  liveVastUrl: PropTypes.string,
  type: PropTypes.string,
  dataFocusLeft: PropTypes.string,
  dataFocusRight: PropTypes.string,
  dataFocusUp: PropTypes.string,
  dataFocusDown: PropTypes.string,
  dataOnSelfFocus: PropTypes.string,
  handleShowDetailPage: PropTypes.func,
  dataOnPagination: PropTypes.string,
};

export default Item;
